import React from "react";
import { EonUiIcon } from "@eon-ui/eon-ui-components-react";

interface ListItemProps {
    label: string;
    listItemClicked: (label: string) => void;
}

export const ListItem: React.FC<ListItemProps> = ({ label, listItemClicked }) => {
    return (
        <li

            className="result-list"
        >
            <button
                className="result-redirection-wrapper"
                onClick={() => listItemClicked(label)}
            >
                {label}
            </button>
        </li>
    );
};
